import * as moment from 'moment';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Patient {
  id: string;
  user: string;
  firstName: string;
  middleName: string;
  lastName: string;
  namePrefix: string;
  nameSuffix: string;
  gender: string;
  dob: string;
  age: number;
  symptomClasses: string[];
  useHouseholdAddress: boolean;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  createdDate: string;
  updatedDate: string;
  household: string;
  phone1: string;
  phone1Type: string;
  phone2: string;
  phone2Type: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.id = data.id;
    this.user = data.user;
    this.firstName = data.firstName;
    this.middleName = data.middleName;
    this.lastName = data.lastName;
    this.namePrefix = data.namePrefix;
    this.nameSuffix = data.nameSuffix;
    this.gender = data.gender;
    this.dob = data.dob;
    if (this.dob) {
      this.age = moment().diff(this.dob, 'years', false);
    }
    if (this.symptomClasses) {
      // Split symptoms by comma
    }
    this.useHouseholdAddress = data.useHouseholdAddress;
    // this.address1 = data.address1;
    this.address1 = data.pAddress1;
    this.address2 = data.pAddress2;
    this.city = data.pCity;
    this.state = data.pState;
    this.zip = data.pZip;
    this.createdDate = data.createdDate;
    this.updatedDate = data.updatedDate;
    this.household = data.household;
    // this.phone1 = data.phone1;
    this.phone1 = data.pPhone1;
    // this.phone1Type = data.phone1Type;
    this.phone1Type = data.pPhone1Type;
    this.phone2 = data.pPhone2;
    this.phone2Type = data.pPhone2Type;
  }
}



// WEBPACK FOOTER //
// ./src/app/patients/patient.ts